export enum Orientation {
  /** 竖屏 */
  VERTICAL,

  /** 横屏 */
  HORIZONTAL,
}

// 'vertical' | 'horizontal'
